import { useEffect } from "react";
import { removeLottieLoading, useAppSelector, useAppTranslation } from "@/utils";
// import { AppStoreStates } from "@/redux/configs";
import { ConfigProvider, theme as ConfigTheme, locales } from "@payping/web-components";
import { RouterProvider } from "react-router";
import { router } from "@/router";
import { SharedUtilitiesConfig } from "@payping/utilities-shared/config";
import { initSentry } from "./initSentry";

initSentry();

function App() {
  const locale = useAppSelector((state) => state.settings.locale);
  const direction = useAppSelector((state) => state.settings.direction);
  const { i18n } = useAppTranslation();

  const { enUS, faIR } = locales;
  const configLocale = {
    en: enUS,
    fa: faIR,
  };

  useEffect(() => {
    SharedUtilitiesConfig.setConfig({ language: locale, direction });
  }, [locale, direction]);

  useEffect(() => {
    removeLottieLoading();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [i18n, locale]);

  return (
    <ConfigProvider
      direction={direction}
      locale={configLocale[locale || "fa"]}
      localeName={locale}
      theme={{
        // algorithm: [
        //   theme === "dark" || (!theme && isBrowserDark) ? ConfigTheme.darkAlgorithm : ConfigTheme.defaultAlgorithm,
        //   ...(compactTheme ? [ConfigTheme.compactAlgorithm] : []),
        // ],
        algorithm: [ConfigTheme.defaultAlgorithm],
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
